/* global facebookPageUserName */
import get from '../../plugins/get';
import moment from 'moment';

export default () => {

  if ($('.community-facebook-events').length) {

    const facebookAPI = 'https://graph.facebook.com/v2.11',
          facebookUser = facebookPageUserName,
          accessToken = '1904889896443226|4e42aa1d0b7cd599b49512cb157713ab',
          query = `${facebookAPI}/${facebookUser}/events?access_token=${accessToken}&fields=name,description,start_time,end_time&time_filter=upcoming&limit=2`;

    // HTTP request with Promise to get latest post
    get(query).then(JSON.parse).then((response) => {

      if (response.data.length) {
        response.data.map((event) => {
          const month = moment(event.start_time).format('MMM');
          const day = moment(event.start_time).format('D');
          const startTime = moment(event.start_time).format('LT');
          const endTime = moment(event.end_time).format('LT');
          const eventTemplate = `
            <a class="community-facebook-events-item" target="_blank" href="https://www.facebook.com/${event.id}">
              <div class="community-facebook-events-item-date">
                <div class="community-facebook-events-item-date-month">${month}</div>
                <div class="community-facebook-events-item-date-day">${day}</div>
              </div>
              <div class="community-facebook-events-item-content">
                <h5 class="community-facebook-events-item-title">${event.name}</h5>
                <div class="community-facebook-events-item-time">${startTime} &ndash; ${endTime}</div>
                <p class="community-facebook-events-item-description">${event.description.trunc(130)} <span class="community-facebook-events-item-description-link">Read More on Facebook</span></p>
              </div>
            </a>
          `;

          $('.community-facebook-events-items').append(eventTemplate);
        });
        $('.community-facebook-events').show();
      }

    });

  }

};
